import { MusicalInstrumentCondition, MusicalInstrumentPurchaseCondition } from './constants';

const attributes = {
  inst_type: {
    friendly: 'Instrument Type',
    validations: {
      maxLength: 150,
    },
  },
  inst_brand: {
    friendly: 'Brand',
    validations: {
      maxLength: 150,
    },
  },
  inst_model: {
    friendly: 'Model',
    validations: {
      maxLength: 150,
    },
  },
  inst_year: {
    friendly: 'Year',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },
  inst_country: {
    friendly: 'Country',
    validations: {
      maxLength: 150,
    },
  },
  inst_editon: {
    friendly: 'Edition',
    validations: {
      maxLength: 255,
    },
  },
  inst_material: {
    friendly: 'Material',
    validations: {
      maxLength: 255,
    },
  },
  inst_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 150,
    },
  },
  inst_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 150,
    },
  },
  inst_serial: {
    friendly: 'Serial No.',
    validations: {
      maxLength: 150,
    },
  },

  inst_accessories: {
    friendly: 'Accessories',
    validations: {
      maxLength: 255,
    },
  },

  inst_conditon: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: MusicalInstrumentCondition,
    },
  },

  inst_purchase_condtion: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: MusicalInstrumentPurchaseCondition,
    },
  },

};

export default attributes;

export const MusicalInstrumentDefaultSplitAttribute = 'inst_type';

export const MusicalInstrumentItemSearchAttributes = [];

export const MusicalInstrumentOverviewAttributes = ['title', 'inst_type', 'inst_model', 'inst_year', 'inst_country', 'inst_conditon', 'rarity', 'market_value',
  'quantity', 'inventory_no', 'tags'];

export const MusicalInstrumentSpecificationAttributes = ['inst_editon', 'inst_material', 'inst_dimensions', 'inst_weight', 'inst_serial', 'inst_accessories'];

export const MusicalInstrumentPurchaseAttributes = ['purchase_date', 'purchase_price', 'inst_purchase_condtion', 'purchase_contact', 'purchase_notes'];

export const MusicalInstrumentDetailAttributes = [];

export const MusicalInstrumentRequiredAttributes = [];

export const MusicalInstrumentDisplayAttributes = ['inst_type', 'inst_brand', 'inst_model', 'inst_year', 'tags'];

export const MusicalInstrumentSliderGalleryAttributes = {
  titleKey: 'inst_type',
  subtitleKey: 'inst_model',
};



// WEBPACK FOOTER //
// ./src/config/musicalInstrumentDataAttributes.js